export const TURNSTILE_TYPE = {
    VGUANG: 0, RFID: 1, ELVIS: 2, ELVIS_BUTTON: 3, TELPO: 4,
    DSN_TURNSTILE: 5, ENIGOO_READER: 6, ENIGOO_FACE_RECOGNITION_READER: 7,
    TICKET_VALIDATOR_SOCKET: 8, UNKNOWN: 9,
};
export const COMMAND = {
    OPEN: "command.open", BLOCK: "command.block", REBOOT: "command.reboot", DISPLAY: "command.display",
    STATUS: "command.status", DEVICE_INFO: "command.device_info", SYNC_NOW: "command.sync_now",
    RESTART_BOARD: "command.restart_board", RESET_COUNT: "command.reset_count", SET_TIME: "command.set_time",
    FREE_PASSAGE: "command.free_passage", READERS: "command.readers", LED: "command.led",
    SEMAPHORE: "command.semaphore", UI: "command.ui", SHUTDOWN: "command.shutdown",
};

// Dotazovací příkazy — bez payloadu, bez rizika, panel je odešle rovnou (žádný formulář,
// viz commandForms.js — hasCommandForm() pro ně vrací false).
const QUERY_ONLY_COMMANDS = [COMMAND.STATUS, COMMAND.DEVICE_INFO, COMMAND.SYNC_NOW];

const LEGACY_OPEN_TYPES = [TURNSTILE_TYPE.ELVIS, TURNSTILE_TYPE.ELVIS_BUTTON, TURNSTILE_TYPE.DSN_TURNSTILE];
export function allowedActions(turnstileType) {
    if (turnstileType === TURNSTILE_TYPE.TICKET_VALIDATOR_SOCKET) {
        return [
            COMMAND.OPEN, COMMAND.BLOCK, COMMAND.REBOOT, COMMAND.DISPLAY,
            ...QUERY_ONLY_COMMANDS,
            COMMAND.RESTART_BOARD, COMMAND.RESET_COUNT, COMMAND.SET_TIME,
            COMMAND.FREE_PASSAGE, COMMAND.READERS, COMMAND.LED, COMMAND.SEMAPHORE, COMMAND.UI, COMMAND.SHUTDOWN,
        ];
    }
    if (LEGACY_OPEN_TYPES.includes(turnstileType)) return [COMMAND.OPEN];
    return [];
}
export function usesLegacyOpen(turnstileType) { return LEGACY_OPEN_TYPES.includes(turnstileType); }

export const TURNSTILE_TYPE_LABEL = {
    [TURNSTILE_TYPE.VGUANG]: "Vguang",
    [TURNSTILE_TYPE.RFID]: "RFID",
    [TURNSTILE_TYPE.ELVIS]: "Elvis",
    [TURNSTILE_TYPE.ELVIS_BUTTON]: "Elvis (tlačítko)",
    [TURNSTILE_TYPE.TELPO]: "Telpo",
    [TURNSTILE_TYPE.DSN_TURNSTILE]: "DSN turniket",
    [TURNSTILE_TYPE.ENIGOO_READER]: "ENIGOO čtečka",
    [TURNSTILE_TYPE.ENIGOO_FACE_RECOGNITION_READER]: "ENIGOO rozpoznávání obličeje",
    [TURNSTILE_TYPE.TICKET_VALIDATOR_SOCKET]: "Ticket validator (socket)",
    [TURNSTILE_TYPE.UNKNOWN]: "Neznámý",
};
export function turnstileTypeLabel(t) {
    return TURNSTILE_TYPE_LABEL[t] != null ? TURNSTILE_TYPE_LABEL[t] : "Neznámý";
}

// EntryType ordinály z backendu: 0=OUT, 1=IN, 2=IN_AREA, ...
export const ENTRY_TYPE_LABEL = {0: "Výstup", 1: "Vstup", 2: "Vstup do zóny"};
export function entryTypeLabel(t) {
    return ENTRY_TYPE_LABEL[t] != null ? ENTRY_TYPE_LABEL[t] : "—";
}

// Stav příkazu → český label + barevná třída (pro historii příkazů).
export const COMMAND_STATE_LABEL = {
    PENDING: "Čeká", SUCCESS: "OK", ERROR: "Chyba",
};

// Chybové kódy z /command → hláška pro uživatele.
export const COMMAND_ERROR_LABEL = {
    COMMAND_PENDING: "Zařízení má nevyřízený příkaz. Počkejte na jeho dokončení.",
    DEVICE_NOT_FOUND: "Turniket neexistuje nebo byl smazán.",
    UNKNOWN_COMMAND: "Neznámý příkaz.",
    UNSUPPORTED_TURNSTILE_TYPE: "Tento typ turniketu příkazy nepodporuje.",
};

// Labely všech typů — sdílí panel v mapě i stránka Spuštěné příkazy.
// Obsahuje i typy, které nejsou v UI jako tlačítka; v historii se objevit můžou.
export const COMMAND_LABEL = {
    [COMMAND.OPEN]: "Otevřít",
    [COMMAND.BLOCK]: "Blokovat",
    [COMMAND.REBOOT]: "Reboot zařízení",
    [COMMAND.DISPLAY]: "Displej",
    [COMMAND.STATUS]: "Stav desky",
    [COMMAND.DEVICE_INFO]: "Info o zařízení",
    [COMMAND.SYNC_NOW]: "Vynutit sync",
    [COMMAND.RESTART_BOARD]: "Restart desky",
    [COMMAND.RESET_COUNT]: "Vynulovat počítadla",
    [COMMAND.SET_TIME]: "Srovnat čas",
    [COMMAND.LED]: "LED",
    [COMMAND.SEMAPHORE]: "Semafor",
    [COMMAND.FREE_PASSAGE]: "Volný průchod",
    [COMMAND.READERS]: "Čtečky",
    [COMMAND.UI]: "UI zařízení",
    [COMMAND.SHUTDOWN]: "Vypnout zařízení",
};

/** Label typu příkazu; neznámý kód se vrátí tak jak je. */
export function commandLabel(type) {
    return COMMAND_LABEL[type] || type;
}

/** Volby pro multiselect filtru typu. */
export const COMMAND_TYPE_OPTIONS = Object.keys(COMMAND_LABEL)
    .map((code) => ({value: code, label: COMMAND_LABEL[code]}));

/** Volby pro multiselect filtru stavu. */
export const COMMAND_STATE_OPTIONS = [
    {value: "PENDING", label: "Čeká"},
    {value: "SUCCESS", label: "OK"},
    {value: "ERROR", label: "Chyba"},
];

const INVALID_PAYLOAD_PREFIX = "INVALID_PAYLOAD:";

/** Přeloží kód chyby z API na hlášku. Neznámý tvar → obecná hláška. */
export function commandErrorMessage(code) {
    if (typeof code === "string") {
        if (code.startsWith(INVALID_PAYLOAD_PREFIX)) {
            return "Neplatný parametr příkazu: " + code.slice(INVALID_PAYLOAD_PREFIX.length) + ".";
        }
        if (COMMAND_ERROR_LABEL[code]) return COMMAND_ERROR_LABEL[code];
    }
    return "Příkaz selhal.";
}
